import IconSvg from 'src/assets/icons/IconSvg';
import IconButton from 'src/components/button/IconButton';
import { useViewport } from 'src/context/ViewportContext';

const AppFooter = () => {
  const { isMobile } = useViewport();

  return (
    <div className="bg-[#10100FB2] py-4 xl:py-3 2xl:px-[104px] px-5 flex justify-end items-center gap-3 fixed bottom-0 left-0 right-0 z-50">
      <button className="flex gap-2 items-center px-4 py-2 text-sm font-medium rounded-lg text-grayscale-200 bg-brand-black">
        <IconSvg icon="gasS" />

        <span>12.49 sat/vB</span>
      </button>

      <button className="flex gap-2.5 items-center px-4 py-2 font-medium text-sm text-grayscale-200 bg-brand-black rounded-lg">
        <IconSvg icon="bitcoinS" />

        <span>$96,200</span>
      </button>

      <IconButton
        icon={isMobile ? 'supportM' : 'supportS'}
        size={isMobile ? 'sm' : 'xs'}
        variant="transparent"
        onlyIcon={isMobile}
      >
        {isMobile ? '' : 'Contact Support'}
      </IconButton>
    </div>
  );
};

export default AppFooter; 
